import { useEffect } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import { Sidebar } from "@/components/admin/Sidebar";
import { DashboardHome } from "@/components/admin/DashboardHome";
import { BlogManagement } from "@/components/admin/BlogManagement";
import { InquiriesManagement } from "@/components/admin/InquiriesManagement";

export default function AdminDashboardPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) navigate("/admin/login");
  }, [navigate]);

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 p-8 lg:p-12">
        <Routes>
          <Route index element={<DashboardHome />} />
          <Route path="blog" element={<BlogManagement />} />
          <Route path="inquiries" element={<InquiriesManagement />} />
        </Routes>
      </main>
    </div>
  );
}
